var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFiPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#fi_phone_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#09F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M18.333 14.1v2.5a1.667 1.667 0 0 1-1.816 1.666 16.5 16.5 0 0 1-7.192-2.558 16.25 16.25 0 0 1-5-5 16.5 16.5 0 0 1-2.558-7.225 1.666 1.666 0 0 1 1.658-1.817h2.5A1.67 1.67 0 0 1 7.592 3.1c.105.8.3 1.586.583 2.342A1.67 1.67 0 0 1 7.8 7.2L6.742 8.258a13.33 13.33 0 0 0 5 5l1.058-1.059a1.67 1.67 0 0 1 1.758-.375 10.7 10.7 0 0 0 2.342.584 1.666 1.666 0 0 1 1.433 1.691"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "fi_phone_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgFiPhone;